import React, {useContext} from 'react';
import {Button, message, Upload} from 'antd';
import {UploadOutlined} from '@ant-design/icons';
import {sideMenuContext} from "../../../router/IndexRouter";
import {Arguments} from "./Arguments";
import {PostImage} from "./ApiMethod";

const SelectFileToUpload = ({uploadExcelPath}) => {
    const {fileList, setFileList} = useContext(sideMenuContext);

    const handleUpload = (file) => {
        const postApi = Arguments.host + '/society_organization/upload/api!uploadFile.do';
        PostImage(postApi, file).then(res => {
            if (res?.data.errno === 0) {
                message.success("文件上传成功")
                // console.log("data  ", res.data)
                uploadExcelPath(res.data.data.url);
            } else {
                message.error("文件上传失败");
            }
        })
    };

    const props = {
        onRemove: (file) => {
            const index = fileList.indexOf(file);
            const newFileList = fileList.slice();
            newFileList.splice(index, 1);
            setFileList(newFileList);
        },
        beforeUpload: (file) => {
            setFileList([...fileList, file]);
            handleUpload(file);
            return false;
        },
        fileList,
    };

    return (
        <Upload {...props} accept=".xls, .xlsx">
            <Button icon={<UploadOutlined/>} disabled={fileList.length >= 1}>选择表格</Button>
        </Upload>
    );
};
export default SelectFileToUpload;